import React from 'react';

const Stats = () => {
  return (
    <div className="stats">
      <h2 className="stats__title">The Stats</h2>
      <div className="stats__content">
        <div className="stats__block-group">
          <div className="stats__block stats__block--half-height">
            <p className="stats__txt">
              According to our report 37% of men pay for household utilities compared to 15% of women.
            </p>
            <div className="stats__circle-group">
              <div className="stats__circle-group-item">
                <span className="stats__circle"></span>
                <p>
                  Men <span>37%</span>
                </p>
              </div>
              <div className="stats__circle-group-item stats__circle-group-item--small">
                <span className="stats__circle stats__circle--small"></span>
                <p>
                  Women <span>15%</span>
                </p>
              </div>
            </div>
          </div>
          <div className="stats__block stats__block--purple stats__block--half-height">
            <p className="stats__txt stats__txt--white">
              46% of women under 55 are more likely to feel guilty when they buy something for themselves compared to
              27% of men in the same category.
            </p>
            <div className="stats__data">
              <p className="stats__txt stats__txt--white">
                <span>46% of women</span>
                <span className="stats__txt stats__txt--white stats__txt--small">100%</span>
              </p>
              <div className="stats__progress">
                <div className="stats__bar"></div>
              </div>
            </div>
            <div className="stats__data">
              <p className="stats__txt stats__txt--white">
                <span>27% of men</span>
                <span className="stats__txt stats__txt--white stats__txt--small">100%</span>
              </p>
              <div className="stats__progress">
                <div className="stats__bar stats__bar--27"></div>
              </div>
            </div>
          </div>
        </div>
        <div className="stats__block stats__block--half-width stats__block--purple">
          <p className="stats__txt stats__txt--medium">
            <span>30% of women</span> believe that being financially autonomous is more important than sharing money
            with their male partner.
          </p>
        </div>
        <div className="stats__block stats__block--full">
          <div className="stats__stat-group">
            <p className="stats__txt stats__txt--large">
              71%<span>women</span>
            </p>
            <p className="stats__txt stats__txt--large">
              67%<span>men</span>
            </p>
          </div>
          <p className="stats__txt stats__txt--half-width">
            71% of women scored themselves as 7 or higher in being confident they can manage their money vs. 67% of men
            who scored the same.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Stats;
